import { render, staticRenderFns } from "./ConversationCell.vue?vue&type=template&id=2d3783a7&scoped=true"
import script from "./ConversationCell.vue?vue&type=script&lang=js"
export * from "./ConversationCell.vue?vue&type=script&lang=js"
import style0 from "./ConversationCell.vue?vue&type=style&index=0&id=2d3783a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3783a7",
  null
  
)

export default component.exports